import { collection, doc, getDocs, updateDoc } from "firebase/firestore"

import { db } from "../../FIREBASECONFIG"

const RESORTS_COLLECTION = "contents"
const RESORTS_PAGE_NAME = "resorts"
const RESORTS_PAGE_TYPE = "page"

export const fetchResortsContent = async () => {
  const snapshot = await getDocs(collection(db, RESORTS_COLLECTION))
  const contents = snapshot.docs.map((docSnap) => ({
    id: docSnap.id,
    ...docSnap.data(),
  }))

  const content =
    contents.find(
      (item) =>
        item.pageName === RESORTS_PAGE_NAME && item.type === RESORTS_PAGE_TYPE
    ) || null

  return { content, contents }
}

export const updateResortsContent = async (id, data) => {
  if (!id) {
    throw new Error("Resorts content document id is required")
  }

  const docRef = doc(db, RESORTS_COLLECTION, id)
  const payload = {
    ...data,
    id,
    pageName: RESORTS_PAGE_NAME,
    type: RESORTS_PAGE_TYPE,
    updatedAt: new Date(),
  }

  await updateDoc(docRef, payload)

  return { id, ...payload }
}